import { Route, Routes } from "react-router-dom";

import StoreExchangeListingPage from "@/pages/conciliation/store-exchange-listing";

export default function StoreExchangeListingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoreExchangeListingPage />} />
    </Routes>
  );
}
